import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
    path: '',
    component: () => import_latest_version_module(),
    children: [
        {
            path: '/admin/trip-edit',
            name: 'admin-trip-edit',
            component: () => import(/* webpackChunkName: "page-admin-trip-management-trip-edit" */ `./index.vue`),
            meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "行程单管理"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "行程单管理"
                                        },
                                        {
                                                  name: "行程单编辑"
                                        }
                              ]
                    }
          }
},
        },
    ],
};
